import { Injectable } from '@angular/core';
import { Http, Response } from '@angular/http';

import { environment } from '../../environments/environment';

@Injectable()
export class ShareholderService {
  constructor(private http: Http) {}

  baseurl = environment.apiBaseUrl;

  // save shareholder in investor architect pages
  saveShareholder(projectId, data) {
    return this.http
      .post(`${this.baseurl}/investors/add`, { projectId, data })
      .map((res: Response) => res.json());
  }

  // get shareholders from DB
  getShareholder(projectId) {
    return this.http
      .post(`${this.baseurl}/investors/get`, { projectId })
      .map((res: Response) => res.json());
  }

  // update name and values of shareholders
  updateShareholder(projectId, data) {
    return this.http
      .post(`${this.baseurl}/investors/update`, { projectId, data })
      .map((res: Response) => res.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/service/shareholder.service.ts